// extracted by mini-css-extract-plugin
export default {"container":"info-description_container__bWfFt","title":"info-description_title__K4tqg","description":"info-description_description__Ssa2L"};